import React from 'react';

// useAsync hooks to lessen the code for using async call inside a use effect
const useAsync = (asyncFn, onSuccess) => {
  React.useEffect(() => {
    let isActive = true;
    asyncFn().then((data) => {
      if (isActive) onSuccess(data);
    });
    return () => {
      isActive = false;
    };
    // eslint-disable-next-line
  }, []);
};

export default useAsync;
